import React, { useState } from 'react'
import { ToggleWrapper, ToggleAction, Toggler } from './styles'

export interface IToggleValue {
  color: string
  value: string
}

interface Props {
  values: IToggleValue[]
  defaultPosition?: number
  onClick: (value: string) => void
  disabled: boolean
}

const Toggle = (props: Props): JSX.Element => {
  const { values, defaultPosition, onClick, disabled } = props
  const [position, setPosition] = useState<number>(defaultPosition || 0)

  if (position > values.length - 1) {
    throw 'Position out of range'
  }

  return (
    <ToggleWrapper color={values[position].color} count={values.length}>
      {values &&
        values.map((value, index) => (
          <ToggleAction
            key={index}
            disabled={disabled}
            onClick={() => {
              onClick(value.value)
              setPosition(index)
            }}
          />
        ))}
      <Toggler position={position} />
    </ToggleWrapper>
  )
}

export default Toggle
